/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeResponseCallback, StockOptions, StockRangeOptions, ThemeDetail } from '../../types';

/**
 * 打开股票详情
 * @param data
 */
export const openStockDetail = (data: StockOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openStockDetail', 'openStockDetail');
    return;
  }
  const params: string = JSON.stringify(data);
  bridgeCallHandler('openStockDetail', params, null);
};

/**
 * 调用客户端打开股票详情页，带范围
 * @param data
 * @returns
 */
export const openStockDetailsWithRange = (data: StockRangeOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openStockDetailsWithRange', 'openStockDetailsWithRange');
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('openStockDetailsWithRange', params, null);
};

/**
 * 获取自选股
 * @param callback
 */
export const getSelfStocks = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('getSelfStocks', 'getSelfStocks');
    return;
  }

  bridgeCallHandler('getSelfStocks', '', callback);
};

/**
 * 打开自选股页面
 * @param groupId
 */
export const openOptionalStockPage = (groupId: string): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openOptionalStockPage', 'openOptionalStockPage');
    return;
  }

  bridgeCallHandler('openOptionalStockPage', groupId, null);
};

/**
 * 调用客户端打开选股页面
 */
export const openSelectStock = (): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openSelectStock', 'openSelectStock');
    return;
  }

  bridgeCallHandler('openSelectStock', '', null);
};

/**
 * 打开自选分组的原生弹框
 */
export const addToSelfStock = (market: number, code: string, callback?: (data: any) => {}): void => {
  if (!isInApp()) {
    printNativeMethodFallback('addToSelfStock', 'addToSelfStock');
    return;
  }
  const params = JSON.stringify({ market, code });
  bridgeCallHandler('addToSelfStock', params, callback ? callback : null);
};

/**
 * 打开题材详情
 */
export const openTCBDetail = (data: ThemeDetail): void => {
  if (!isInApp()) {
    printNativeMethodFallback('openTCBDetail', 'openTCBDetail');
    return;
  }
  const params = JSON.stringify(data);
  bridgeCallHandler('openTCBDetail', params, null);
};

/**
 * 搜索股票
 */
export const searchStock = (callback: BridgeResponseCallback): void => {
  if (!isInApp()) {
    printNativeMethodFallback('searchStock', 'searchStock');
    return;
  }
  bridgeCallHandler('searchStock', '', callback);
};
